// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import {
  COMPANY__CONTACT_PERSON_NAME,
  COMPANY__CONTACT_PERSON_GENDER,
  COMPANY__CONTACT_PERSON_PRIVACY_POLICY,
  COMPANY__CONTACT_PERSON_EMAIL,
  COMPANY__CONTACT_PERSON_PHONE_NUMBER,
  COMPANY__CONTACT_PERSON_COMMUNICATION_ONLY_VIA_BANK_ADVISOR
} from "./formFields";
import { mapBoolean, mapGender } from "./mappers";

type OkpContactPersonInfoProps = {
  initialValues: {
    [COMPANY__CONTACT_PERSON_NAME]: string,
    [COMPANY__CONTACT_PERSON_GENDER]: string,
    [COMPANY__CONTACT_PERSON_PRIVACY_POLICY]: string,
    [COMPANY__CONTACT_PERSON_EMAIL]: string,
    [COMPANY__CONTACT_PERSON_PHONE_NUMBER]: string,
    [COMPANY__CONTACT_PERSON_COMMUNICATION_ONLY_VIA_BANK_ADVISOR]: string
  },
  numberedWithDot?: boolean
};

const OkpContactPersonInfo = ({ initialValues, numberedWithDot }: OkpContactPersonInfoProps) => (
  <Section title="Ansprechperson im Unternehmen" reducedMargin numberedWithDot={numberedWithDot}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_NAME,
            caption: () => "Name"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_GENDER,
            caption: () => "Anrede"
          }}
          displayValue={mapGender}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_PRIVACY_POLICY,
            caption: () => "Datenschutz"
          }}
          displayValue={mapBoolean}
        />
      </FormRow>

      <FormRow>
        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_EMAIL,
            caption: () => "E-Mail"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_PHONE_NUMBER,
            caption: () => "Telefon"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__CONTACT_PERSON_COMMUNICATION_ONLY_VIA_BANK_ADVISOR,
            caption: () => "Kommunikation NUr über Bankberater"
          }}
          displayValue={mapBoolean}
        />
      </FormRow>
    </EditableForm>
  </Section>
);

OkpContactPersonInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpContactPersonInfo;
